import { render } from "./MonthCardWillExpire.vue?vue&type=template&id=a37d4ae8&scoped=true"
import script from "./MonthCardWillExpire.vue?vue&type=script&lang=js"
export * from "./MonthCardWillExpire.vue?vue&type=script&lang=js"

import "./MonthCardWillExpire.vue?vue&type=style&index=0&id=a37d4ae8&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37d4ae8"]])

export default __exports__